<template>
  <div class="mainDrawer">
    <el-drawer
      title="设置"
      :visible.sync="drawer"
      direction="ttb"
      size="100%"
      :with-header="false"
      :wrapperClosable="false"
      :modal="false">
      <el-row class="btn-group">
        <el-col :span="4" style="display: flex;justify-content: start;align-items: center">
          <!--          <el-image :src="closeUrl" fit="fill" style="height: 14px;width: 14px;margin-left: 30px"></el-image>-->
          <img class="back" src="@/assets/images/back.png" alt="返回" @touchstart="back" @click="back">
        </el-col>
        <el-col :span="16" style="display: flex;justify-content: center;align-items: center">
          <el-popover
            width="70"
            trigger="hover"
            popper-class="popoverStyle"
            content="撤回">
            <div slot="reference" class="popoverChild" @touchstart="Undo" @click="Undo">
              <img style="height: 20px;width: 20px" src="../../../assets/images/antVx6/recode.png"/>
            </div>
          </el-popover>
          <el-popover
            width="70"
            trigger="hover"
            popper-class="popoverStyle"
            content="放大">
            <div slot="reference" class="popoverChild" @touchstart="changeGraphZoom(0.2)" @click="changeGraphZoom(0.2)">
              <img style="height: 20px;width: 20px" src="../../../assets/images/antVx6/up.png"/>
            </div>
          </el-popover>
          <el-popover
            width="70"
            trigger="hover"
            popper-class="popoverStyle"
            content="缩小">
            <div slot="reference" class="popoverChild" @touchstart="changeGraphZoom(-0.2)"  @click="changeGraphZoom(-0.2)">
              <img style="height: 20px;width: 20px" src="../../../assets/images/antVx6/down.png"/>
            </div>
          </el-popover>
          <div class="bar"></div>
          <el-checkbox-group v-model="openDoubleHeadedLine" size="mini" @change="changeLineTypeDouble" style="padding-top: 5px"
                             class="popoverChild">
            <el-checkbox-button label="doubleHeaded">
              <el-popover
                width="100"
                trigger="hover"
                popper-class="popoverStyle"
                content="双向箭头">
                <div slot="reference">
                  <img style="height: 6px;width: 20px" src="../../../assets/images/antVx6/doubleHeaded.png"/>
                </div>
              </el-popover>
            </el-checkbox-button>
          </el-checkbox-group>
          <el-checkbox-group v-model="openDubboLine" size="mini" @change="changeLineType" style="padding-top: 5px"
                             class="popoverChild">
            <el-checkbox-button label="dubbo">
              <el-popover
                width="100"
                trigger="hover"
                popper-class="popoverStyle"
                content="双向箭头">
                <div slot="reference">
                  <img style="height: 6px;width: 20px" src="../../../assets/images/antVx6/dubboLine.png"/>
                </div>
              </el-popover>
            </el-checkbox-button>
          </el-checkbox-group>
          <el-radio-group v-model="lineType" size="mini" @input="changeEdgeType" class="lineClass">
            <el-radio-button :label="line.label" v-for="(line,index) in lineList" :key="index">
              <el-popover
                width="100"
                trigger="hover"
                popper-class="popoverStyle"
                :content="line.name">
                <div slot="reference">
                  <el-image :src="line.icon" fit="fill" style="height: 15px;width: 15px"></el-image>
                </div>
              </el-popover>
            </el-radio-button>
          </el-radio-group>
          <el-checkbox-group v-model="openDynamicLine"  size="mini" @change="changeDynamicLine" style="margin-left: 20px;padding-top: 5px"
                             class="popoverChild">
            <el-checkbox-button label="dynamic">
              <el-popover
                width="100"
                trigger="hover"
                popper-class="popoverStyle"
                content="动态虚线">
                <div slot="reference">
                  <span style="font-size: 16px;color:#07E6F8">- - -</span>
                </div>
              </el-popover>
            </el-checkbox-button>
          </el-checkbox-group>
          <div style="height: 60%;border:1px solid #4d4b4b;opacity: 0.6;margin: 0 20px 0 20px"></div>
          <el-popover
            width="70"
            trigger="hover"
            popper-class="popoverStyle"
            content="删除">
            <div slot="reference" @touchstart="deleteNode()" @click="deleteNode()" class="popoverChild">
              <img style="height: 30px;width: 30px" src="../../../assets/images/antVx6/shanchu.png"/>
            </div>
          </el-popover>
          <el-popover
            width="150"
            trigger="hover"
            popper-class="popoverStyle"
            content="保存为PNG图片">
            <div slot="reference" @touchstart="saveImageForm('PNG')"  @click="saveImageForm('PNG')" class="popoverChild">
              <img style="height: 30px;width: 30px" src="../../../assets/images/antVx6/png.png"/>
            </div>
          </el-popover>
          <el-popover
            width="150"
            trigger="hover"
            popper-class="popoverStyle"
            content="保存为SVG图片">
            <div slot="reference" @touchstart="saveImageForm('SVG')"  @click="saveImageForm('SVG')" class="popoverChild">
              <img style="height: 30px;width: 30px" src="../../../assets/images/antVx6/svg.png"/>
            </div>
          </el-popover>
        </el-col>
        <el-col :span="4" style="display: flex;justify-content: end;align-items: center">
          <el-button class="saveClass" size="mini" @touchstart="saveJson()" @click="saveJson()">保 存</el-button>
        </el-col>
      </el-row>
    </el-drawer>
  </div>
</template>

<script>
import {DataUri} from "@antv/x6";
import {save} from "@/network/device-topology"

export default {
  name: 'TopDrawer',
  props: ['graph', 'spaceId', 'topologyId'],
  data() {
    return {
      drawer: true,
      // 关闭编辑器图标
      closeUrl: require('../../../assets/images/antVx6/close.png'),
      // 线 类型
      lineType: 'normal',
      lineList: [
        {name: '直线箭头', label: 'normal', icon: require('../../../assets/images/antVx6/straightLine.png')},
        {name: '曲线箭头', label: 'smooth', icon: require('../../../assets/images/antVx6/curve.png')},
        {name: '直角箭头', label: 'rightAngle', icon: require('../../../assets/images/antVx6/rightAngle.png')}
      ],
      // 是否开启双向箭头
      openDubboLine: false,
      openDoubleHeadedLine: false,
      openDynamicLine: false,
      // 保存为png的名称
      pngName: '',
      // 保存为svg的名称
      svgName: ''
    };
  },
  methods: {
    back() {
      this.$router.go(-1);
    },
    // 撤回
    Undo() {
      console.log(this.graph.canUndo())
      if (this.graph.canUndo()) {
        this.graph.undo()
      } else {
        this.$message.warning("未查到历史操作记录，无法撤销！")
      }

    },
    // 删除节点
    deleteNode() {
      this.$emit('deleteNode')
    },
    // 改变连线箭头
    changeEdgeType() {
      this.$emit('changeEdgeType', this.lineType)
    },
    // 缩放画布
    changeGraphZoom(value) {
      this.graph.zoom(value)
    },
    // 改变箭头类型
    changeLineType() {
      this.openDoubleHeadedLine = false
      this.$emit('changeLineType', this.openDubboLine)
    },
    // 
    changeLineTypeDouble() {
      this.openDubboLine = false
      this.$emit('changeLineTypeDouble', this.openDoubleHeadedLine)
    },
    // 改变动态虚线状态
    changeDynamicLine() {
      this.$emit('changeDynamicLine', this.openDynamicLine)
    },
    // 保存png
    saveToPNG() {
      this.$nextTick(() => {
        this.graph.toPNG((dataUri) => {
          // 下载
          DataUri.downloadDataUri(dataUri, this.pngName)
        }, {
          backgroundColor: 'white',
          padding: {
            top: 50,
            right: 50,
            bottom: 50,
            left: 50
          },
          quality: 1,
          copyStyles: false
        })
      })
    },
    // 保存svg
    saveToSVG() {
      this.$nextTick(() => {
        this.graph.toSVG((dataUri) => {
          // 下载
          DataUri.downloadDataUri(DataUri.svgToDataUrl(dataUri), this.svgName + ".svg")
        }, {
          copyStyles: false
        })
      })
    },
    // 保存图片名称表单
    saveImageForm(imageType) {
      this.$prompt('请输入' + imageType + '名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({value}) => {
        if (imageType === 'PNG') {
          this.pngName = value
          this.saveToPNG()
        } else if (imageType === 'SVG') {
          this.svgName = value
          this.saveToSVG()
        }
        this.$message({
          type: 'warning',
          message: '正在将内容转换成' + imageType + '格式图片...'
        });
      });
    },
    // 保存JSON
    saveJson() {
      let data = this.graph.toJSON();
      const cells = this.graph.getCells();

      if (!cells.length) {
        this.$message.error('未检测到任何图形，无法保存！');
        return;
      }

      // 获取所有内容的边界
      const contentArea = this.graph.getContentArea();
      
      // 保存原始视图状态
      const originalScale = this.graph.scale();
      const originalPoint = this.graph.translate();

      this.$prompt('请输入拓扑图名称', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(({ value }) => {
        this.$nextTick(() => {
          // 临时调整视图以确保导出合适的区域
          this.graph.scale(1);
          this.graph.centerContent();

          this.graph.toSVG(
            (dataUri) => {
              let object = {
                id: this.topologyId,
                spaceId: this.spaceId,
                name: value,
                dataJson: JSON.stringify(data),
                svgData: dataUri,
                note: '',
                width: contentArea.width,
                height: contentArea.height,
                x: contentArea.x,
                y: contentArea.y
              };

              // 恢复原始视图状态
              this.graph.scale(originalScale.sx, originalScale.sy);
              this.graph.translate(originalPoint.tx, originalPoint.ty);

              save(object)
                .then(() => {
                  this.$message.success('保存为 JSON 成功！');
                })
                .catch((e) => {
                  this.$message.error('保存为 JSON 失败！');
                  console.log(e);
                });
            },
            {
              preserveDimensions: true,
              copyStyles: true,
              viewBox: contentArea,
              width: contentArea.width,
              height: contentArea.height,
              serializeImages: true,
              converter: (svg) => {
                // 移除任何额外的transform
                return svg.replace(/transform="[^"]*"/g, '');
              }
            }
          );
        });
      });
    }
  }
};
</script>

<style scoped>
.back {
  width: 36px;
  height: 36px;
  cursor: pointer;
}
.mainDrawer {
  display: flex;
  justify-content: center;
}

.btn-group {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 10px 0 10px;
}

.lineClass {
  width: 170px;
  height: 100%;
  padding-top: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #373F51;
}

.popoverChild {
  margin-right: 36px;
  cursor: pointer;
}

.saveClass {
  background: #07E6F8;
  border-radius: 14px 14px 14px 14px;
  font-size: 14px;
  font-family: Regular;
  color: #050F26;
  margin-right: 40px;
}

.closeMap {
  font-size: 18px;
  color: #07E6F8;
  margin-left: 20px;
}

.bar {
  height: 30px;
  border: 1px solid #373F51;
  margin-right: 36px;
}

@keyframes closeAnimate {
  0% {
    right: 20%;
  }
  100% {
    right: 0;
  }
}

::v-deep .el-drawer__wrapper {
  width: 100%;
  height: 8%;
  border-bottom: 1px solid #0E2E48;
}

::v-deep .el-drawer__body {
  background: #050F26;
}
</style>
<style>

.el-popover.popoverStyle {
  background-color: rgba(70, 76, 91, .9);
  border: rgba(70, 76, 91, .9);
  color: white;
  min-width: 70px;
}

.el-popover .popper__arrow::after {
  border-bottom-color: rgba(70, 76, 91, .9) !important;
}
</style>
